// src/components/tools/ToolCard.js
import React, { useState } from 'react';

const ToolCard = ({ icon, name, description, route, setPage }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: hovered ? 'rgba(255,255,255,0.07)' : 'rgba(255,255,255,0.03)',
        border: hovered ? '1px solid rgba(0,221,255,0.35)' : '1px solid rgba(255,255,255,0.09)',
        borderRadius: 16,
        padding: '28px 24px',
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        cursor: 'pointer',
        transition: 'all 0.22s ease',
        boxShadow: hovered ? '0 8px 32px rgba(0,221,255,0.08)' : '0 2px 12px rgba(0,0,0,0.3)',
        transform: hovered ? 'translateY(-3px)' : 'translateY(0)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* subtle glow on hover */}
      {hovered && (
        <div style={{
          position: 'absolute', top: 0, left: 0, right: 0, height: 1,
          background: 'linear-gradient(90deg, transparent, rgba(0,221,255,0.5), transparent)',
          pointerEvents: 'none',
        }} />
      )}

      {/* Icon */}
      <div style={{
        width: 52, height: 52, borderRadius: 14,
        background: 'rgba(0,221,255,0.08)',
        border: '1px solid rgba(0,221,255,0.18)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 24,
        flexShrink: 0,
      }}>
        {icon}
      </div>

      {/* Name */}
      <h3 style={{
        fontSize: 17, fontWeight: 700, color: '#f1f5f9',
        margin: 0, letterSpacing: '-0.01em',
      }}>
        {name}
      </h3>

      {/* Description */}
      <p style={{
        fontSize: 13.5, color: '#94a3b8', lineHeight: 1.65,
        margin: 0, flex: 1,
      }}>
        {description}
      </p>

      {/* Open Tool button */}
      <button
        onClick={() => setPage(route)}
        style={{
          marginTop: 4,
          display: 'inline-flex', alignItems: 'center', gap: 6,
          padding: '9px 18px', borderRadius: 9999,
          fontSize: 13, fontWeight: 600,
          color: '#0ea5e9',
          background: 'rgba(14,165,233,0.10)',
          border: '1px solid rgba(14,165,233,0.25)',
          cursor: 'pointer', transition: 'all 0.18s',
          alignSelf: 'flex-start',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = 'rgba(14,165,233,0.20)';
          e.currentTarget.style.borderColor = 'rgba(14,165,233,0.5)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = 'rgba(14,165,233,0.10)';
          e.currentTarget.style.borderColor = 'rgba(14,165,233,0.25)';
        }}
      >
        Open Tool
        <svg style={{ width: 13, height: 13 }} viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L10.939 10 7.23 6.29a.75.75 0 111.06-1.06l4.24 4.24a.75.75 0 010 1.06l-4.24 4.24a.75.75 0 01-1.08-.02z" clipRule="evenodd" />
        </svg>
      </button>
    </div>
  );
};

export default ToolCard;
